if (!customElements.get('buy-button-price')) {
  customElements.define(
    'buy-button-price',
    class BuyButtonPrice extends HTMLElement {
      connectedCallback() {
        this.button = this.closest('button');
        this.quantityInput = this.closest('product-info')?.querySelector('.quantity__input');
        this.onQuantityChange = this.render.bind(this);

        this.quantityInput?.addEventListener('change', this.onQuantityChange);
        this.quantityInput?.addEventListener('input', this.onQuantityChange);

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));

        if (this.button) {
          this.observer = new MutationObserver(this.syncAvailability.bind(this));
          this.observer.observe(this.button, { attributes: true, attributeFilter: ['disabled'] });
        }

        this.render();
        this.syncAvailability();
      }

      disconnectedCallback() {
        this.quantityInput?.removeEventListener('change', this.onQuantityChange);
        this.quantityInput?.removeEventListener('input', this.onQuantityChange);
        this.variantChangeUnsubscriber?.();
        this.observer?.disconnect();
      }

      onVariantChange({ data: { sectionId, html } }) {
        const productInfo = this.closest('product-info');
        if (!productInfo) return;
        if ((productInfo.dataset.originalSection || productInfo.dataset.section) !== sectionId) return;

        const source = html.getElementById(`ProductSubmitButton-${sectionId}`)?.querySelector('buy-button-price');
        if (source) {
          this.dataset.unitPrice = source.dataset.unitPrice;
          this.dataset.moneyFormat = source.dataset.moneyFormat;
        }

        this.render();
        this.syncAvailability();
      }

      render() {
        const unitPrice = parseInt(this.dataset.unitPrice, 10);
        const format = this.dataset.moneyFormat;
        if (isNaN(unitPrice) || !format) return;

        this.innerHTML = this.formatMoney(unitPrice * this.quantity, format);
      }

      get quantity() {
        const value = parseInt(this.quantityInput?.value, 10);
        return isNaN(value) || value < 1 ? 1 : value;
      }

      formatMoney(cents, format) {
        const placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/);
        if (!placeholder) return format;

        const withDelimiters = (precision, thousands, decimal) => {
          const [whole, fraction] = (cents / 100).toFixed(precision).split('.');
          return whole.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`) + (fraction ? decimal + fraction : '');
        };

        let value;
        switch (placeholder[1]) {
          case 'amount_no_decimals':
            value = withDelimiters(0, ',', '.');
            break;
          case 'amount_with_comma_separator':
            value = withDelimiters(2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = withDelimiters(0, '.', ',');
            break;
          case 'amount_with_space_separator':
            value = withDelimiters(2, ' ', ',');
            break;
          case 'amount_no_decimals_with_space_separator':
            value = withDelimiters(0, ' ', ',');
            break;
          case 'amount_with_apostrophe_separator':
            value = withDelimiters(2, "'", '.');
            break;
          default:
            value = withDelimiters(2, ',', '.');
            break;
        }

        return format.replace(/\{\{\s*\w+\s*\}\}/, value);
      }

      syncAvailability() {
        this.classList.toggle('hidden', !this.button || this.button.hasAttribute('disabled'));
      }
    }
  );
}
